import { render, staticRenderFns } from "./myLeasson.vue?vue&type=template&id=b52beef4"
import script from "./myLeasson.vue?vue&type=script&lang=js"
export * from "./myLeasson.vue?vue&type=script&lang=js"
import style0 from "./myLeasson.vue?vue&type=style&index=0&id=b52beef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports